/**
 * The rules that are true on every route, at phone width.
 *
 * The app carries no stylesheet — each surface styles itself inline — so the
 * handful of rules that can only be written as media queries live in scoped
 * `<style>` blocks, one per surface. This is the shared one: App mounts it
 * once, and every view can reach for the utility classes below rather than
 * inventing its own breakpoint.
 *
 * `!important` on nearly all of it, deliberately: an inline style beats a
 * stylesheet rule unless the rule is important, and inline is where all the
 * layout lives. Nothing here fires above `MOBILE_MAX`.
 */

/**
 * The one breakpoint. 720px is under the narrow side of a small tablet and
 * comfortably over the wide side of a large phone, so it separates "this is
 * a column of content" from "this is a page with columns".
 */
export const MOBILE_MAX = 720

export const responsiveStyles = `
/* Nothing may push the viewport sideways. Canvases (the WebGL scenes) size
   themselves from their container and images arrive from outside the app. */
img, canvas { max-width: 100%; }

@media (max-width: ${MOBILE_MAX}px) {
  /* Page gutters. 28px on each edge is a sixth of a phone's width. */
  .orion-pad { padding-left: 16px !important; padding-right: 16px !important; }

  /* iOS Safari zooms the page in when a control smaller than 16px takes
     focus, and does not zoom back out afterwards. Every input in the app is
     12–13px, which is right on a desktop and a trap on a phone. */
  input, select, textarea { font-size: 16px !important; }

  /* For anything costing more room than it earns on a phone. */
  .orion-sm-hide { display: none !important; }

  /* Fixed multi-column rows fall back to "the name, and one thing beside
     it"; the columns that drop out carry .orion-sm-hide. */
  .orion-sm-row { grid-template-columns: minmax(0, 1fr) auto !important; gap: 12px !important; }

  /* Side-by-side becomes stacked. */
  .orion-sm-stack { grid-template-columns: minmax(0, 1fr) !important; }
}
`
